import React, { useEffect } from "react";
import Close from "../assets/Close";
import { motion, AnimatePresence } from "framer-motion";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const ContactInfo = ({ show, onClose }) => {
  const phoneNumber = "+961 76 624 565";
  const email = "info@thebooker.online";

  const copyPhoneNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    toast.success("Phone number copied to clipboard!");
  };

  const copyEmail = () => {
    navigator.clipboard.writeText(email);
    toast.success("Email copied to clipboard!");
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  const anim = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0, scale: 0.5, transition: { duration: 0.3 } },
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="modal"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={anim}
        >
          <div>
            <div style={{ position: "relative" }}>
              <div className="modal-x-btn" onClick={onClose}>
                <Close width={50} height={50} />
              </div>

              <div className="modal-main">
                <div
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "grid",
                  }}
                >
                  <h1>Contact Us!</h1>
                  <p style={{ marginTop: "20px", marginBottom: "20px" }}>
                    If you need any assistance, please don't hesitate to reach
                    out to us. We're here to help!
                  </p>

                  <div
                    className="ContactInfo"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0 20% 0 0",
                      color: "white",
                      marginBottom: "10px",
                      translate: "35%",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{ marginRight: "10px", fontSize: "20px" }}
                    />
                    <p
                      onClick={copyPhoneNumber}
                      style={{ cursor: "pointer", textDecoration: "underline" }}
                    >
                      {phoneNumber}
                    </p>
                  </div>

                  <div
                    className="ContactInfo"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      translate: "31%",
                      padding: "0 20% 0 0",
                      color: "white",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ marginRight: "10px", fontSize: "20px" }}
                    />
                    <p
                      onClick={copyEmail}
                      style={{ cursor: "pointer", textDecoration: "underline" }}
                    >
                      {email}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ContactInfo;
